module.exports = __webpack_public_path__ + "static/media/diktat-14.d38b6ff1.mp3";